import { render, staticRenderFns } from "./ActivityAddressAdd.vue?vue&type=template&id=0f4efcec&scoped=true&"
import script from "./ActivityAddressAdd.vue?vue&type=script&lang=js&"
export * from "./ActivityAddressAdd.vue?vue&type=script&lang=js&"
import style0 from "./ActivityAddressAdd.vue?vue&type=style&index=0&id=0f4efcec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4efcec",
  null
  
)

export default component.exports